<template>
  <div>
    <DeleteModal
      class="display-none-print"
      modalId="modal-delete"
      @deleteToggle="deleteItem"
    />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? `${$t('common.add')} ${$t('office.vital-sign')}`
          : `${$t('common.edit')} ${$t('office.vital-sign')}`
      "
      @ok="submitItem()"
    >
      <b-card-text>
        <b-row>
          <b-col md="4" cols="12">
            <b-form-group
              :label="$t('office.vital-signs-types')"
              label-for="status"
            >
              <AutoComplete
                v-model="EditForm.vital_sign_type"
                placeholder="Select vital sign type"
                :serializer="(val) => val"
                endpoint="vital-sign-types"
                text-title="name"
                @input="setVitalSignTypeValue"
              />
              <div
                class="d-flex justify-content-between"
                v-if="vital_sign_type_value.max || vital_sign_type_value.min"
              >
                <span
                  >({{ $t("common.minValue") }} -
                  {{ vital_sign_type_value.min }})</span
                >
                <span>
                  ({{ $t("common.maxValue") }} -
                  {{ vital_sign_type_value.max }})</span
                >
              </div>
            </b-form-group>
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.value')" label-for="value">
              <b-form-input
                v-model="EditForm.value"
                :placeholder="$t('common.value')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.date')" label-for="date">
              <datetime
                input-class="form-control"
                type="datetime"
                v-model="EditForm.date"
              >
              </datetime>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>
    <b-card :title="$t('office.vital-signs')">
      <div>
        <b-row class="display-none-print">
          <b-col cols="12" md="12">
            <h2>{{ $t("common.filter") }} {{ $t("office.vital-signs") }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group
              :label="$t('office.vital-signs-types')"
              label-for="Name"
            >
              <AutoComplete
                v-model="typeFilter"
                placeholder="Select vital sign type"
                :serializer="(val) => val.name"
                endpoint="vital-sign-types"
                text-title="name"
                @input="setVitalSignTypeValue"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.date')" label-for="Name">
              <datepicker
                v-model="dateFilter"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row class="display-none-print">
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getVitalSigns()" >
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div
          class="d-flex justify-content-between mt-4 mb-2 display-none-print"
        >
          <h2 class="display-none-print">
            {{ $t("common.table") }} {{ $t("office.vital-signs") }} :{{
              $route.params.name
            }}
          </h2>

          <div class="d-flex">
            <b-button
              variant="primary"
              class="display-none-print mx-1"
              @click="show(EditForm, 'create')"
              :disabled="!is_active"
            >
              {{ $t("common.create") }} {{ $t("office.vital-sign") }}
            </b-button>
            <!-- <PrintVitalSignVue
              :refresh="refresh"
              :url="fetchUrl"
              :data="printData"
            /> -->
          </div>
        </div>
        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative display-none-print"
          v-if="!loading"
        >
          <!-- Column: Actions -->
          <template #cell(value)="data">
            <span
              class="px-1"
              v-if="data.item.result_as_to_normal_range.is_normal"
              >{{ data.item.value }}</span
            >
            <span class="px-1" v-else style="color: red">{{
              data.item.value
            }}</span>
            <!-- Check if the message contains "Below" -->
            <feather-icon
              v-if="
                data.item.result_as_to_normal_range.message.includes('Below')
              "
              icon="ArrowDownIcon"
              size="18"
            />

            <!-- Check if the message contains "Above" -->
            <feather-icon
              v-else-if="
                data.item.result_as_to_normal_range.message.includes('Above')
              "
              icon="ArrowUpIcon"
              size="18"
            />
            <span class="px-1">{{
              data.item.result_as_to_normal_range.message
            }}</span>
          </template>

          <template #cell(normal_value)="data">
            <span
              >{{ data.item.vital_sign_type_data.min_normal_value }} -
              {{ data.item.vital_sign_type_data.max_normal_value }}</span
            >
          </template>
          <template #cell(actions)="data">
            <ActionsButtons
              deletePerm="delete-patient-doctor-note"
              editPerm="update-patient-doctor-note"
              @editToggle="show(data.item)"
              @deleteToggle="deleteModel(data.item)"
              :disabled="!is_active"
            />
          </template>
        </b-table>

        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner :label="$t('common.loading')" />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2 display-none-print">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
                {{ $t("reception.doctor-notes") }}</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getVitalSigns()"
            >
              <b-pagination
                v-model="page"
                :total-rows="this.dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
      <!-- <VitalSignsCharts :refresh="refresh" :url="fetchUrl" /> -->
    </b-card>

    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <!-- Drug Prescription -->
    <DeleteModal
      class="display-none-print"
      modalId="modal-delete-drug-prescription"
      @deleteToggle="deleteDrugPrescription"
    />
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-drug-prescription"
      centered
      size="lg"
      :title="$t('office.patient-drug-prescription')"
      @ok="submitDrugPrescription()"
    >
      <!-- Custom Footer -->
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitDrugPrescription"
          class="m-0"
          :disabled="drugPrescriptionLoading"
          ref="button"
          block
        >
          <span v-if="!drugPrescriptionLoading">{{ $t("common.submit") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('office.source_of_drug')">
              <v-select
                v-model="drugPrescriptionForm.source_of_drug"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[
                  { label: 'Hospital', value: 'hospital' },
                  { label: 'Pharmacy', value: 'pharmacy' },
                  { label: 'External', value: 'external' },
                ]"
                :reduce="(option) => option.value"
                :placeholder="$t('office.source_of_drug')"
                @input="handleSourceChange"
              />
            </b-form-group>
          </b-col>

          <b-col
            md="6"
            v-if="
              drugPrescriptionForm.source_of_drug !== 'external' &&
              drugPrescriptionForm.source_of_drug === 'pharmacy'
            "
          >
            <AutoComplete
              :label="$t('common.drug_scientific_name')"
              :placeholder="$t('common.drug_scientific_name')"
              v-model="drug_scientific_name_id"
              :serializer="(val) => val.id"
              endpoint="drugScientificName"
              text-title="name"
            />
            <AutoComplete
              :disabled="!drugPrescriptionForm.source_of_drug"
              :label="$t('office.item_name')"
              :placeholder="$t('office.item_name')"
              v-model="drugPrescriptionForm.item_id"
              :serializer="(val) => val.id"
              endpoint="item"
              text-title="name"
              :otherQuery="`filter[type]=${drugPrescriptionForm.source_of_drug}&filter[drug_scientific_name_id]=${drug_scientific_name_id}`"
            />
          </b-col>
          <b-col
            md="6"
            v-if="
              drugPrescriptionForm.source_of_drug !== 'external' &&
              drugPrescriptionForm.source_of_drug === 'hospital'
            "
          >
            <AutoComplete
              :disabled="!drugPrescriptionForm.source_of_drug"
              :label="$t('office.item_name')"
              :placeholder="$t('office.item_name')"
              v-model="drugPrescriptionForm.item_id"
              :serializer="(val) => val.id"
              endpoint="item"
              text-title="name"
              :otherQuery="`filter[type]=${drugPrescriptionForm.source_of_drug}`"
            />
          </b-col>
          <b-col
            md="6"
            v-if="drugPrescriptionForm.source_of_drug === 'external'"
          >
            <b-form-group :label="$t('office.item_name_external')">
              <b-form-input
                v-model="drugPrescriptionForm.item_name"
                :placeholder="$t('office.item_name_external')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('office.number_of_doses')">
              <b-form-input
                type="number"
                v-model="drugPrescriptionForm.number_of_doses"
                :placeholder="$t('office.number_of_doses')"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('office.duration_between_doses')">
              <b-form-input
                v-model="drugPrescriptionForm.duration_between_doses"
                :placeholder="$t('office.duration_between_doses')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('office.type')">
              <b-form-input
                v-model="drugPrescriptionForm.type"
                :placeholder="$t('office.type')"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('office.dose')">
              <b-form-input
                v-model="drugPrescriptionForm.dose"
                :placeholder="$t('office.dose')"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12">
            <b-form-group :label="$t('office.start_time')">
              <datetime
                input-class="form-control"
                type="datetime"
                v-model="drugPrescriptionForm.start_time"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group :label="$t('office.description')">
              <b-form-textarea
                v-model="drugPrescriptionForm.description"
                :placeholder="$t('office.description')"
                rows="3"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <!-- Add new modal for editing drug table entry -->
    <!-- Add new modal for adding drugs to patient -->
    <!-- Add new modal for adding drugs to patient -->
    <!-- Add new modal for adding drugs to patient -->
    <!-- Add new modal for adding drugs to patient -->
    <!-- Add new modal for adding drugs to patient -->
    <b-modal
      id="modal-add-drug-to-patient"
      centered
      :title="$t('emergency.add-drug-to-patient')"
    >
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitAddDrugToPatient"
          :disabled="addDrugLoading"
          block
        >
          <span v-if="!addDrugLoading">{{ $t("common.submit") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>

      <b-card-text>
        <b-row>
          <!-- Department field - only shown for hospital source -->
          <b-col
            md="12"
            v-if="selectedDrug && selectedDrug.source_of_drug === 'hospital'"
          >
            <AutoComplete
              :label="$t('office.department')"
              :placeholder="$t('office.department')"
              v-model="addDrugForm.department_id"
              :serializer="(val) => val.id"
              endpoint="departments"
              text-title="name"
              :required="true"
              @input="handleDepartmentChange"
            />
          </b-col>

          <!-- Item field -->
          <!-- <b-col md="12">
            <AutoComplete
              v-if="selectedDrug && selectedDrug.source_of_drug !== 'external'"
              :label="$t('emergency.item')"
              :placeholder="$t('emergency.item')"
              v-model="addDrugForm.item_id"
              :serializer="(val) => val.id"
              endpoint="item"
              text-title="name"
              :otherQuery="departmentQuery"
            />

            <b-form-group v-else :label="$t('emergency.item_name_external')">
              <b-form-input
                v-model="addDrugForm.item_name"
                :placeholder="$t('emergency.item_name_external')"
              />
            </b-form-group>
          </b-col> -->

          <!-- Quantity field -->
          <b-col md="12">
            <b-form-group :label="$t('emergency.quantity')">
              <b-form-input
                type="number"
                v-model="addDrugForm.quantity"
                :placeholder="$t('emergency.quantity')"
                min="1"
              />
            </b-form-group>
          </b-col>

          <!-- Time field -->
          <b-col md="12">
            <b-form-group :label="$t('emergency.time')">
              <datetime
                input-class="form-control"
                type="datetime"
                v-model="addDrugForm.time"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <b-card :title="$t('office.patient-drug-prescription')">
      <!-- Data Table  -->
      <div class="d-flex justify-content-between mt-4 mb-2 display-none-print">
        <h2 class="display-none-print">
          {{ $t("common.table") }}
          {{ $t("office.patient-drug-prescription") }} :{{ $route.params.name }}
        </h2>

        <div class="d-flex">
          <b-button
            variant="primary"
            class="display-none-print mx-1"
            @click="showDrugPrescription(EditForm, 'create')"
            :disabled="!is_active"
          >
            {{ $t("common.create") }}
            {{ $t("office.patient-drug-prescription") }}
          </b-button>
          <!-- <PrintVitalSignVue
            :refresh="refresh"
            :url="fetchUrl"
            :data="printData"
          /> -->
        </div>
      </div>
      <b-table
        :items="dataDrugPrescription"
        responsive
        :fields="tableColumnsDrugPrescription"
        primary-key="id"
        show-empty
        empty-text="No matching results found"
        class="position-relative display-none-print"
        v-if="!drugPrescriptionLoading"
      >
        <template #cell(actions)="data">
          <ActionsButtons
            deletePerm="delete-patientCardPrescription"
            editPerm="update-patientCardPrescription"
            @editToggle="showDrugPrescription(data.item)"
            @deleteToggle="deleteModelDrugPrescription(data.item)"
            :disabled="!is_active"
          />
        </template>
        <template #cell(item_drug_name)="data">
          <span v-if="data.item.item != null">
            <span
              v-if="data.item.source_of_drug === 'pharmacy'"
              style="text-transform: uppercase; color: #000"
              >({{ data.item.drug_scientific_name.name }})</span
            >
            {{ getNestedProperty(data.item, "item.name") }}
          </span>
          <span v-else>
            {{ data.item.item_name }}
            <span class="text-danger">
              ({{ $t("common.item_is_external") }})
            </span>
          </span>
        </template>
        <template #cell(add_drug_to_patient)="data">
          <b-button
            size="sm"
            variant="outline-primary"
            class="mb-75 mx-1"
            @click="showAddDrugModal(data.item)"
            :disabled="!is_active"
          >
            {{ $t("emergency.add-drug-to-patient") }}
          </b-button>
        </template>
      </b-table>

      <template v-if="drugPrescriptionLoading">
        <div>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner :label="$t('common.loading')" />
          </div>
        </div>
      </template>
      <div class="mx-2 mb-2 display-none-print">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >{{ $t("common.showing") }} 1 {{ $t("common.to") }} 10
              {{ $t("reception.doctor-notes") }}</span
            >
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="getVitalSigns()"
          >
            <b-pagination
              v-model="pageDrugPrescription"
              :total-rows="dataCountDrugPrescription"
              :per-page="takeDrugPrescription"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <!-- Patient Drug Table -->
    <!-- Add new modal for editing drug table entry -->
    <b-modal
      id="modal-edit-drug-table-entry"
      centered
      :title="$t('emergency.edit-drug-entry')"
      @ok="submitEditDrugTableEntry"
    >
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitEditDrugTableEntry"
          :disabled="editDrugTableLoading"
          block
        >
          <span v-if="!editDrugTableLoading">{{ $t("common.submit") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>

      <b-card-text>
        <b-row>
          <b-col md="12">
            <b-form-group :label="$t('emergency.quantity')">
              <b-form-input
                type="number"
                v-model="editDrugTableForm.quantity"
                :placeholder="$t('emergency.quantity')"
                min="1"
                :disabled="true"
              />
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group :label="$t('emergency.time')">
              <datetime
                input-class="form-control"
                type="datetime"
                v-model="editDrugTableForm.time"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <!-- Add delete confirmation modal -->
    <DeleteModal
      class="display-none-print"
      modalId="modal-delete-drug-table-entry"
      @deleteToggle="submitDeleteDrugTableEntry"
    />

    <b-card :title="$t('emergency.patient-drug-table')">
      <b-row>
        <!-- Loop through drug prescriptions -->
        <b-col
          v-for="drug in dataDrugPrescription"
          :key="drug.id"
          cols="12"
          class="mb-3"
        >
          <div
            class="shadow-sm"
            style="border: 0.5px solid #000; border-radius: 10px; padding: 10px"
          >
            <!-- Drug Prescription Details -->
            <b-card class="mb-2 border-primary">
              <b-card-title class="d-flex align-items-center border-bottom pb-2 mb-2">
                <strong class="text-primary mr-2">{{ drug.source_of_drug === 'pharmacy' ? drug.drug_scientific_name.name : '' }}</strong>
                <span>{{ drug.item ? getNestedProperty(drug, "item.name") : drug.item_name }}</span>
                <span v-if="!drug.item" class="text-danger ml-1">({{ $t("common.item_is_external") }})</span>
              </b-card-title>
              <b-row>
                <b-col md="4" sm="6" class="mb-2">
                  <div class="d-flex">
                    <span class="font-weight-bold mr-1">{{ $t("office.dose") }}:</span>
                    <span>{{ drug.dose }}</span>
                  </div>
                </b-col>
                <b-col md="4" sm="6" class="mb-2">
                  <div class="d-flex">
                    <span class="font-weight-bold mr-1">{{ $t("office.type") }}:</span>
                    <span>{{ drug.type }}</span>
                  </div>
                </b-col>
                <b-col md="4" sm="6" class="mb-2">
                  <div class="d-flex">
                    <span class="font-weight-bold mr-1">{{ $t("office.source_of_drug") }}:</span>
                    <span class="text-capitalize">{{ drug.source_of_drug }}</span>
                  </div>
                </b-col>
                <b-col md="4" sm="6" class="mb-2">
                  <div class="d-flex">
                    <span class="font-weight-bold mr-1">{{ $t("office.number_of_doses") }}:</span>
                    <span>{{ drug.number_of_doses }}</span>
                  </div>
                </b-col>
                <b-col md="4" sm="6" class="mb-2">
                  <div class="d-flex">
                    <span class="font-weight-bold mr-1">{{ $t("office.duration_between_doses") }}:</span>
                    <span>{{ drug.duration_between_doses }}</span>
                  </div>
                </b-col>
                <b-col md="4" sm="6" class="mb-2">
                  <div class="d-flex">
                    <span class="font-weight-bold mr-1">{{ $t("office.start_time") }}:</span>
                    <span>{{ formatDateTime(drug.start_time) }}</span>
                  </div>
                </b-col>
              </b-row>
            </b-card>

            <!-- Drug Table Entries -->
            <div class="mt-3">
              <h6>{{ $t("emergency.drug-entries") }} :</h6>
              <div class="d-flex flex-column">
                <div
                  v-for="entry in drug.patient_card_drug_table"
                  :key="entry.id"
                  class="mb-2"
                >
                  <b-card class="border">
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <div class="d-flex align-items-center" style="flex: 1">
                        <div class="mr-4">
                          <strong>{{ $t("emergency.time") }}:</strong>
                          {{ formatDateTime(entry.time) }}
                        </div>
                        <div>
                          <strong>{{ $t("emergency.quantity") }}:</strong>
                          {{ entry.quantity }}
                        </div>
                      </div>
                      <div>
                        <b-button
                          variant="outline-primary"
                          size="sm"
                          class="mr-1"
                          @click="editDrugTableEntry(entry)"
                        >
                          {{ $t("common.edit") }}
                        </b-button>
                        <b-button
                          variant="outline-danger"
                          size="sm"
                          @click="deleteDrugTableEntry(entry)"
                        >
                          {{ $t("common.delete") }}
                        </b-button>
                      </div>
                    </div>
                  </b-card>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <div class="d-flex justify-content-center">
        <ShoAndNursing
          :data="dataDrugPrescription"
          :newVitalSignData="newVitalSignData"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BCardText,
  BCardTitle,
  BIcon,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import { Datetime } from "vue-datetime";
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import "vue-datetime/dist/vue-datetime.css";
import AutoComplete from "@/components/common/AutoComplete.vue";
import ShoAndNursing from "@/components/printables/ShoAndNursing.vue";
export default {
  mixins: [permissionChecker],
  components: {
    BCard,
    BCardTitle,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormTextarea,
    Datetime,
    ActionsButtons,
    DeleteModal,
    Datepicker,
    vSelect,
    AutoComplete,
    BIcon,
    ShoAndNursing,
    BCardText,
  },
  data() {
    return {
      take: 100,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      pationtData: {},
      data: [],
      date: new Date(Date.now()).toISOString(),
      EditForm: {
        date: "",
        value: "",
        vital_sign_type: "",
        patient_card_id: this.$route.params.id,
        _method: "PUT",
      },
      vital_sign_type_value: {
        min: 0,
        max: 0,
      },
      createMode: false,
      errorForm: {
        date: "",
        value: "",
        vital_sign_type: "",
        patient_card_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      chartData: {
        labels: [], // Will be filled with dates
        datasets: [],
      },
      tableColumns: [
        {
          key: "vital_sign_type",
          label: this.$t("office.vital_sign_type"),
          sortable: true,
        },
        {
          key: "normal_value",
          label: this.$t("office.normal_value"),
          sortable: true,
        },
        { key: "value", label: this.$t("common.value"), sortable: true },
        { key: "date", label: this.$t("common.date"), sortable: true },

        { key: "Actions", label: this.$t("common.actions") },
      ],

      // Drug Prescription
      tableColumnsDrugPrescription: [
        {
          key: "item_drug_name",
          label: this.$t("office.item_name"),
          sortable: true,
        },
        // {
        //   key: "item_name",
        //   label: this.$t("office.item_name_external"),
        //   sortable: true,
        // },
        {
          key: "number_of_doses",
          label: this.$t("office.number_of_doses"),
          sortable: true,
        },
        {
          key: "duration_between_doses",
          label: this.$t("office.duration_between_doses"),
          sortable: true,
        },
        {
          key: "source_of_drug",
          label: this.$t("office.source_of_drug"),
          sortable: true,
        },
        { key: "type", label: this.$t("office.type"), sortable: true },
        { key: "dose", label: this.$t("office.dose"), sortable: true },
        {
          key: "start_time",
          label: this.$t("office.start_time"),
          sortable: true,
        },
        {
          key: "description",
          label: this.$t("office.description"),
          sortable: true,
        },
        {
          key: "add_drug_to_patient",
          label: this.$t("emergency.add-drug-to-patient"),
        },

        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      printData: false,
      refresh: false,
      fetchUrl: "",
      typeFilter: null,
      dataCountDrugPrescription: 0,
      pageDrugPrescription: 1,
      takeDrugPrescription: 100,
      dataDrugPrescription: [],
      patientCardId: this.$route.params.id,
      dateFilter: null,
      allItems: [],
      drugPrescriptionLoading: false,
      drugPrescriptionForm: {
        item_id: null,
        item_name: "",
        number_of_doses: "",
        duration_between_doses: "",
        source_of_drug: "",
        type: "",
        dose: "",
        start_time: new Date().toISOString(),
        description: "",
      },
      errorDrugPrescriptionForm: {
        item_id: null,
        item_name: "",
        number_of_doses: "",
        duration_between_doses: "",
        source_of_drug: "",
        type: "",
        dose: "",
        start_time: new Date().toISOString(),
        description: "",
      },
      addDrugForm: {
        department_id: null,
        item_id: null,
        quantity: "",
        time: null,
      },
      selectedDrug: null,
      departmentQuery: "",
      addDrugLoading: false,
      editDrugTableForm: {
        quantity: "",
        time: "",
      },
      editDrugTableLoading: false,
      newVitalSignData: [],
      drug_scientific_name_id: null,
      is_active: this.$route.params.is_active == true ,
    };
  },
  mounted() {
    this.getVitalSigns();
    this.getDrugPrescription();
    },
  methods: {
    setVitalSignTypeValue(value) {
      this.vital_sign_type_value = {
        min: value.min_normal_value,
        max: value.max_normal_value,
      };
    },
    printPage() {
      this.$refs.html2PdfExaminationTable.generatePdf();
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      if (!date || isNaN(date)) {
        return "";
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:00`;
    },
    formatDateWithoutTime(unformatedDate) {
      const date = new Date(unformatedDate);

      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      // Return the formatted date string
      return `${year}-${month}-${day}`;
    },
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          date: new Date().toISOString(),
          value: "",
          vital_sign_type: "",
          patient_card_id: this.$route.params.id,
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.value = item.value;
        this.EditForm.date = new Date(item.date).toISOString();
        this.EditForm.vital_sign_type = item.vital_sign_type;
        this.EditForm.patient_card_id = item.patient_card_id;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },

    async getVitalSigns() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/vital-signs?filter[patient_card_id]=${this.$route.params.id}&include=patientCard,vitalSignTypeData&page=${this.page}&take=${this.take}&sort=-id`;

      if (this.typeFilter) {
        url += `&filter[vital_sign_type]=${this.typeFilter}`;
      }
      if (this.dateFilter) {
        url += `&filter[date]=${this.formatDateWithoutTime(this.dateFilter)}`;
      }
      this.fetchUrl = url;
      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.formatVitalSign();
      this.printData = this.data;
      // this.prepareChartData(this.data);
      this.loading = false;
      this.refresh = !this.refresh;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/vital-signs/${this.deleteForm.id}`)
        .then((response) => {
          this.getVitalSigns();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      // console.log("result", result);
      return result;
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      this.EditForm.date = this.formatDate(this.EditForm.date);
      this.EditForm.vital_sign_type = this.getNestedProperty(
        this.EditForm.vital_sign_type,
        "name"
      );
      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/vital-signs`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getVitalSigns();
              this.setVitalSignTypeValue({
                min_normal_value: 0,
                max_normal_value: 0,
              });
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/vital-signs/${this.EditForm.id}?_method=PUT`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getVitalSigns();
              this.setVitalSignTypeValue({
                min_normal_value: 0,
                max_normal_value: 0,
              });
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },

    // //////////////////////// drug prescription ////////////////////////
    async getDrugPrescription() {
      this.drugPrescriptionLoading = true;
      let url = `/patientCardPrescriptions?filter[patient_card_id]=${this.$route.params.id}&include=patientCard,patientCardDrugTable,item,drugScientificName&page=${this.pageDrugPrescription}&take=${this.takeDrugPrescription}&sort=-id`;
      await this.getList(url);
      this.dataCountDrugPrescription = this.all_data.total;
      const copyData = this.all_data.data;

      this.dataDrugPrescription = copyData;
      this.drugPrescriptionLoading = false;
      // console.log(this.dataDrugPrescription, 'dataDrugPrescription');
    },
    // async getAllItems() {
    //   let url = `/item?take=2000`;
    //   await this.getList(url);
    //   this.allItems = this.all_data.data;
    //   console.log(this.allItems, "allItems");
    // },
    handleSourceChange(value) {
      this.drugPrescriptionForm.item_name = "";
      this.drugPrescriptionForm.item_id = null;
    },
    showDrugPrescription(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        // Reset form for new entry
        this.drugPrescriptionForm = {
          item_id: null,
          item_name: "",
          number_of_doses: "",
          duration_between_doses: "",
          source_of_drug: "",
          type: "",
          dose: "",
          start_time: new Date().toISOString(),
          description: "",
          patient_card_id: this.$route.params.id,
          _method: "POST",
        };
      } else {
        this.createMode = false;
        // Fill form with existing data for edit
        this.drugPrescriptionForm = {
          id: item.id,
          item_id: item.item_id,
          item_name: item.item_name,
          number_of_doses: item.number_of_doses,
          duration_between_doses: item.duration_between_doses,
          source_of_drug: item.source_of_drug,
          type: item.type,
          dose: item.dose,
          start_time: new Date(item.start_time).toISOString(),
          description: item.description,
          patient_card_id: item.patient_card_id,
          _method: "PUT",
        };
      }

      // Show the modal
      this.$bvModal.show("modal-drug-prescription");
    },
    submitDrugPrescription() {
      let count = 0;
      this.drugPrescriptionLoading = true;

      // Reset error messages
      this.errorDrugPrescriptionForm = {
        item_id: "",
        item_name: "",
        number_of_doses: "",
        duration_between_doses: "",
        source_of_drug: "",
        type: "",
        dose: "",
        start_time: "",
        description: "",
      };

      if (this.drugPrescriptionForm.source_of_drug === "external") {
        this.drugPrescriptionForm.item_id = null;
      } else {
        this.drugPrescriptionForm.item_name = "";
      }

      // Clear empty fields from form
      for (let item in this.errorDrugPrescriptionForm) {
        if (
          this.drugPrescriptionForm[item] === "" ||
          this.drugPrescriptionForm[item] === null
        ) {
          delete this.drugPrescriptionForm[item];
        }
      }

      // Validate required fields
      if (this.drugPrescriptionForm.source_of_drug === "external") {
        if (!this.drugPrescriptionForm.item_name) {
          count++;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Validation Error",
              variant: "danger",
              text: "The item name field is required",
            },
          });
        }
      } else {
        if (!this.drugPrescriptionForm.item_id) {
          count++;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Validation Error",
              variant: "danger",
              text: "The item field is required",
            },
          });
        }
      }

      if (!this.drugPrescriptionForm.number_of_doses) {
        count++;
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Validation Error",
            variant: "danger",
            text: "The number of doses field is required",
          },
        });
      }

      if (!this.drugPrescriptionForm.duration_between_doses) {
        count++;
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Validation Error",
            variant: "danger",
            text: "The duration between doses field is required",
          },
        });
      }

      if (!this.drugPrescriptionForm.source_of_drug) {
        count++;
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Validation Error",
            variant: "danger",
            text: "The source of drug field is required",
          },
        });
      }

      if (count > 0) {
        this.drugPrescriptionLoading = false;
        return false;
      }

      // Format date
      if (this.drugPrescriptionForm.start_time) {
        this.drugPrescriptionForm.start_time = this.formatDate(
          this.drugPrescriptionForm.start_time
        );
      }

      this.drugPrescriptionForm.patient_card_id = this.$route.params.id;
      console.log(this.drugPrescriptionForm, "drugPrescriptionForm");

      // Create or Update
      const params = {
        form: this.drugPrescriptionForm,
        path: this.createMode
          ? "/patientCardPrescriptions"
          : `/patientCardPrescriptions/${this.drugPrescriptionForm.id}`,
      };

      this.$store
        .dispatch(this.createMode ? "create" : "update", params)
        .then((response) => {
          this.drugPrescriptionLoading = false;
          this.$bvModal.hide("modal-drug-prescription");
          this.getDrugPrescription();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: this.createMode
                ? "Created Successfully"
                : "Updated Successfully",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.drugPrescriptionLoading = false;
          if (error.response?.status === 400) {
            for (let item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Validation Error",
                  variant: "danger",
                  text: error.response.data[item][0],
                },
              });
            }
          }
        });
    },
    deleteModelDrugPrescription(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete-drug-prescription");
    },
    deleteDrugPrescription() {
      this.drugPrescriptionLoading = true;
      this.$store
        .dispatch("delete", `/patientCardPrescriptions/${this.deleteForm.id}`)
        .then((response) => {
          this.getDrugPrescription();
          this.$bvModal.hide("modal-delete-drug-prescription");
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.item_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.drugPrescriptionLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.item_name,
            },
          });
        });
    },

    // //////////////////////// print ////////////////////////
    showAddDrugModal(item) {
      this.selectedDrug = item;
      console.log(this.selectedDrug, "selectedDrug");
      this.addDrugForm = {
        patient_card_prescription_id: item.id,
        time: new Date(item.start_time).toISOString(),
        department_id: null,
        item_id:
          item.item_id &&
          (item.source_of_drug === "hospital" ||
            item.source_of_drug === "pharmacy")
            ? item.item_id
            : null,
        quantity: "",
        time: "",
      };
      if (item.source_of_drug === "external") {
        this.addDrugForm.item_id = null;
        this.addDrugForm.item_name = item.item_name;
      }
      console.log(this.addDrugForm, "addDrugForm");
      this.$bvModal.show("modal-add-drug-to-patient");
    },
    submitAddDrugToPatient() {
      const form = {
        patient_card_prescription_id: this.addDrugForm.patient_card_prescription_id,
        time: this.formatDate(this.addDrugForm.time),
        department_id: this.addDrugForm.department_id,
        item_id: this.addDrugForm.item_id,
        quantity: this.addDrugForm.quantity,
      };
      // console.log(form, "form");
      // return;
      this.addDrugLoading = true;
      this.$store
        .dispatch("create", {
          form: form,
          path: "/patientCardDrugTables",
        })
        .then((response) => {
          this.addDrugLoading = false;
          this.$bvModal.hide("modal-add-drug-to-patient");
          this.getDrugPrescription();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Drug Added Successfully",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.addDrugLoading = false;
          if (error.response?.status === 400) {
            for (let item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Validation Error",
                  variant: "danger",
                  text: error.response.data[item],
                },
              });
            }
          }
        });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      if (!date || isNaN(date)) {
        return "";
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:00`;
    },
    handleDepartmentChange(value) {
      //   this.addDrugForm.item_id = null;
      //   this.departmentQuery = `filter[department_id]=${value}`;
    },
    formatDateTime(datetime) {
      if (!datetime) return "";
      const date = new Date(datetime);
      return date.toLocaleString();
    },
    editDrugTableEntry(entry) {
      this.editDrugTableForm = {
        quantity: entry.quantity,
        time: new Date(entry.time).toISOString(),
        _method: "PUT",
      };
      console.log(entry, "entry");
      this.selectedDrug = entry.id;

      this.$bvModal.show("modal-edit-drug-table-entry");
    },
    submitEditDrugTableEntry() {
      this.editDrugTableLoading = true;
      this.editDrugTableForm.time = this.formatDate(
        this.editDrugTableForm.time
      );
      this.$store
        .dispatch("update", {
          form: this.editDrugTableForm,
          path: `/patientCardDrugTables/${this.selectedDrug}`,
        })
        .then((response) => {
          this.editDrugTableLoading = false;
          this.$bvModal.hide("modal-edit-drug-table-entry");
          this.getDrugPrescription();
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Drug Entry Updated Successfully",
              variant: "success",
            },
          });
        })
        .catch((error) => {
          this.editDrugTableLoading = false;
          if (error.response?.status === 400) {
            for (let item in error.response.data) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Validation Error",
                  variant: "danger",
                  text: error.response.data[item][0],
                },
              });
            }
          }
        });
    },
    deleteDrugTableEntry(entry) {
      this.deleteForm = entry;
      this.$bvModal.show("modal-delete-drug-table-entry");
    },
    submitDeleteDrugTableEntry() {
      this.drugPrescriptionLoading = true;
      this.$store
        .dispatch("delete", `/patientCardDrugTables/${this.deleteForm.id}`)
        .then((response) => {
          this.getDrugPrescription();
          this.$bvModal.hide("modal-delete-drug-table-entry");
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.quantity + " successfully",
            },
          });
        })
        .catch((error) => {
          this.drugPrescriptionLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.quantity,
            },
          });
        });
    },
    formatVitalSign() {
      // Initialize empty arrays for each vital sign type
      let temperatureVitals = [];
      let pulseVitals = [];

      // Sort the data into respective arrays
      this.data.forEach((item) => {
        if (item.vital_sign_type === "temperature") {
          temperatureVitals.push(item);
        } else if (item.vital_sign_type === "pulse") {
          pulseVitals.push(item);
        }
      });

      // Sort each array by date in ascending order
      temperatureVitals.sort((a, b) => new Date(a.date) - new Date(b.date));
      pulseVitals.sort((a, b) => new Date(a.date) - new Date(b.date));

      // Format dates if needed
      temperatureVitals.forEach((item) => {
        item.date = this.formatDate(item.date);
      });
      pulseVitals.forEach((item) => {
        item.date = this.formatDate(item.date);
      });

      // Set the newVitalSignData with the grouped and sorted data
      this.newVitalSignData = [
        {
          type: "temperature",
          vitals: temperatureVitals,
        },
        {
          type: "pulse",
          vitals: pulseVitals,
        },
      ];
      console.log(this.newVitalSignData, "newVitalSignData");
    },
  },
};
</script>
<style scoped>
/* CSS */

.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.chart {
  page-break-inside: avoid;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
